import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { Menu } from '../aceternity/navbar-menu';
import { faHeart, faShoppingCart, faUser, faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import persistStore from 'redux-persist/es/persistStore';
import store from '../redux/store';
import { FaBars } from 'react-icons/fa6';
import { FaStore } from 'react-icons/fa'; // Importing a suitable icon for Shop

const Shop_Nav = () => {
  const persistor = persistStore(store);
  const clearReduxStore = () => {
    persistor.purge();
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropDown = () => {
    setIsOpen((prev) => !prev);
  };

  const cartCount = useSelector((state) => state.cart.cartList.length);
  const wishCount = useSelector((state) => state.cart.wishlist.length);

  return (
    <div className="bg-white text-pink-600 shadow-lg sticky top-0 z-50">
      <div className="flex justify-between items-center p-4">
        {/* Logo and Brand Name */}
        <Link to="/" className="flex items-center space-x-2">
          <img src="/assets/logoSvg.svg" alt="Logo" className="h-10 w-10" />
          <span className="cinzel text-[#56736D] text-xl font-bold">Karishma's Closet</span>
        </Link>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden cursor-pointer" onClick={toggleDropDown}>
          <FaBars size={28} />
        </div>

        {/* Desktop Icons */}
        <div className="hidden md:flex items-center space-x-4 text-gray-600">
          
          {/* Home Button */}
          <Link to="/" className="p-2 hover:bg-gray-100 rounded-md transition duration-300 flex flex-col relative hover:text-[blue]">
            <FontAwesomeIcon icon={faHome} className="text-xl" />
            <span className="text-xs mt-1 font-bold">Home</span>
          </Link>

          {/* Shop Button */}
          <Link to="/shop" className="p-2 hover:bg-gray-100 rounded-md transition duration-300 flex flex-col relative hover:text-[green] ">
            <FaStore className="text-xl ml-auto mr-auto" />
            <span className="text-xs mt-1 font-bold">Shop</span>
          </Link>

          {/* Wishlist Button */}
          <Link to="/wishlist" className="p-2 hover:bg-gray-100 rounded-md transition duration-300 flex flex-col relative hover:text-[red]">
            <FontAwesomeIcon icon={faHeart} className="text-xl" />
            <span className="text-xs mt-1 font-bold">Wishlist</span>
            {wishCount >= 0 && (
              <span className="absolute -top-2 -right-0 bg-pink-400 text-white rounded-full text-xs px-2 py-1 font-bold">
                {wishCount}
              </span>
            )}
          </Link>

          {/* Cart Button */}
          <Link to="/cart" className="p-2 hover:bg-gray-100 rounded-md transition duration-300 flex flex-col relative hover:text-[blue]">
            <FontAwesomeIcon icon={faShoppingCart} className="text-xl" />
            <span className="text-xs mt-1 font-bold">Cart</span>
            {cartCount >= 0 && (
              <span className="absolute -top-2 -right-2 bg-red-600 text-white rounded-full text-xs px-2 py-1 font-bold">
                {cartCount}
              </span>
            )}
          </Link>

          {/* Profile Button */}
          <Link to="/profile" className="p-2 hover:bg-gray-100 rounded-md transition duration-300 flex flex-col hover:text-[black]" onClick={clearReduxStore}>
            <FontAwesomeIcon icon={faUser} className="text-xl" />
            <span className="text-xs mt-1 font-bold">Profile</span>
          </Link>
        </div>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <Link
            to="/"
            className="block px-4 py-2 hover:bg-gray-100 transition duration-300"
          >
            Home
          </Link>
          <Link
            to="/shop"
            className="block px-4 py-2 hover:bg-gray-100 transition duration-300"
          >
            Shop
          </Link>
          <Link
            to="/wishlist"
            className="block px-4 py-2 hover:bg-gray-100 transition duration-300"
          >
            Wishlist
          </Link>
          <Link
            to="/cart"
            className="block px-4 py-2 hover:bg-gray-100 transition duration-300"
          >
            Cart
          </Link>
          <Link
            to="/profile"
            className="block px-4 py-2 hover:bg-gray-100 transition duration-300"
            onClick={clearReduxStore}
          >
            Profile
          </Link>
        </div>
      )}
    </div>
  );
};

export default Shop_Nav;
